import { SpriteConstant } from 'src/app/constant/sprite.constant';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';
import { UtilService } from 'src/app/util/UtilService';
import { AlertPlayerRegisterPopupLayoutComponent } from '../core/alertPlayerRegisterPopup.layout.component';

@Component({
    selector: 'app-alertPlayerRegisterPopup',
    templateUrl: './alertPlayerRegisterPopup.layout.mobile.component.html',
    styleUrls: ['../css/alertPlayerRegisterPopup.layout.mobile.component.scss'],
    standalone: false
})
export class AlertPlayerRegisterPopupMobileComponent extends AlertPlayerRegisterPopupLayoutComponent {
  @Input() alertData: any;
  @Output() eventEmit: EventEmitter<any> = new EventEmitter<any>();
  @Input() currentLanguage = 'en';
  @Input() userCurrency: any = 'USD';
  @Input() AlertPlayerRegisterPopupEnable: boolean = false;
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.RegisterPopup(false);
  }
  constructor(public _utilService: UtilService) {
    super(_utilService);
    if (this.alertData) {
      //console.log("this.alertData---PlayForFunAlertLayoutMobileComponent",this.alertData)
      this.AlertPlayerRegisterPopupEnable =
        this.alertData.AlertPlayerRegisterPopupEnable;
      this.currentLanguage = this.alertData.currentLanguage;
    }
  }

  ngOnInit() {
    //console.log("this.alertData---PlayForFunAlertLayoutMobileComponent",this.alertData)
    if (this.alertData) {
      //console.log("this.alertData---PlayForFunAlertLayoutMobileComponent",this.alertData)
      this.AlertPlayerRegisterPopupEnable =
        this.alertData.AlertPlayerRegisterPopupEnable;
      this.currentLanguage = this.alertData.currentLanguage;
    }
  }
  RegisterPopup = (data) => {
    this.AlertPlayerRegisterPopupEnable = false;
    const RegisterPopupClick: any = {};
    RegisterPopupClick.AlertPlayerRegisterPopupEnable = data;
    this.eventEmit.emit(RegisterPopupClick);
  };
}
